import { DesignSystem } from '@/src/design-system'
import { H4, SizableText, View, YStack } from 'tamagui'
import * as Branding from '@/src/experiences/branding'

export function SectionHeader({ title, subtitle }: { title: string; subtitle?: string }) {
  const { token: primaryColorToken } = Branding.Hooks.usePrimaryColor()
  return (
    <YStack self="flex-start">
      <View height={4} width={48} bg={primaryColorToken} />
      <H4 color="$textHeading">{title}</H4>
      {subtitle && (
        <SizableText size="$3" opacity={0.75}>
          {subtitle}
        </SizableText>
      )}
    </YStack>
  )
}

export function SectionHeaderSkeleton() {
  return (
    <YStack self="stretch">
      <View height={4} width={48} bg="$shadowColor" />
      <DesignSystem.Skeleton.Skeleton
        style={{ width: 180, height: 24, overflow: 'hidden', borderRadius: 16 }}
      />
      <View height={8} />
      <DesignSystem.Skeleton.Skeleton
        style={{ width: '100%', height: 16, overflow: 'hidden', borderRadius: 16 }}
      />
      <View height={8} />
      <DesignSystem.Skeleton.Skeleton
        style={{ width: '65%', height: 16, overflow: 'hidden', borderRadius: 16 }}
      />
    </YStack>
  )
}
